<template>
  <div>
    <div class="mb-6" v-html="$t('bloodReport.finalStep.text')" />
    <div
      v-for="(item, index) in $t('bloodReport.finalStep.list', { returnObjects: true })"
      :key="index"
      class="d-flex align-center grey rounded-lg pa-4"
      :class="{
        'mt-2': index > 0
      }"
    >
      <div class="mr-2">
        <v-img width="48" height="48" contain :src="$asset(`img/icons/${listIcons[index]}.svg`)" />
      </div>
      <div class="py-0 text-left">
        <div class="text-label grey-darken-1--text">{{ item.title }}</div>
        <div class="text-h3">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BloodTestFinalStep',
  props: {
    identifier: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      link: '',
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      returnData: 'dynamicForms/returnData'
    }),
    listIcons() {
      return ['bloodtest', `calendar/date-${new Date().getDate()}`, 'report'];
    }
  },
  watch: {
    loading() {
      this.setDialogData();
    }
  },
  beforeDestroy() {
    this.setDialogLeftHeaderIconType('static');
    this.setDialogLeftHeaderIconComponent('');
  },
  async mounted() {
    await this.$http
      .get(`/v3/fe/questions/${this.returnData.identifier}`)
      .then(data => {
        this.link = data.redirectLink;
      })
      .catch(err => {
        this.handleError({ error: err, code: '0x0000001B' });
      })
      .finally(() => {
        this.loading = false;
      });

    this.setDialogData();
    await this.updateDialogTitle(this.$t('bloodReport.finalStep.title'));
    this.$store.commit('forms/emergencyDisclaimer/setIsEmergencyChecked', false);
    await this.updateHeaderType('information');
    await this.setDialogLeftHeaderIconType('animated');
    await this.setDialogLeftHeaderIconComponent('Confetti');
  },
  methods: {
    setDialogData() {
      this.updateDialogButtons([
        {
          type: 'sendButton',
          props: {
            loading: this.loading
          },
          events: {
            click: () => {
              this.newTab(this.link, true);
              this.$emit('close');
            }
          },
          text: this.$t('bloodReport.finalStep.button')
        }
      ]);
    },
    ...mapActions({
      updateDialogButtons: 'profile/bloodTestForm/setDialogButtons',
      updateDialogTitle: 'profile/bloodTestForm/setDialogTitle',
      updateHeaderType: 'profile/bloodTestForm/setDialogHeaderType',
      setDialogLeftHeaderIconType: 'profile/bloodTestForm/setDialogLeftHeaderIconType',
      setDialogLeftHeaderIconComponent: 'profile/bloodTestForm/setDialogLeftHeaderIconComponent'
    })
  }
};
</script>
